import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["size"];
import * as React from "react";
import { SIZE_OPTIONS } from "../primitives/IllustrationPrimitive/consts";
import IllustrationPrimitive from "../primitives/IllustrationPrimitive";

const Illustration = _ref => {
  let {
    size = SIZE_OPTIONS.MEDIUM
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(IllustrationPrimitive, _extends({}, props, {
    size: size
  }));
};

export default Illustration;